import { CCol, CRow } from "@coreui/react-pro";
import { ToastInfo } from "@/components/shared/toast/Toast";
import { useEffect, useState } from "react";
import { formatUSDNoCurrency } from "@/shared/utils/ultils";

interface Props {
  user: any;
  config: any;
}
const ListRoom = ({ user, config }: Props) => {
  const [listPhong, setListPhong] = useState([
    {
      name: "Phòng 1: Thị trường nông sản tổng hợp",
      intro: "(Phòng 1: Thị trường nông sản tổng hợp)",
      des: "Tối thiểu 0",
      url: "https://gialuongthucthegioi.com/user/rooms/thuong",
      soLuong: Math.floor(Math.random() * 10500000),
    },
    {
      name: "Phòng 2: Thị trường Kim Loại - Khoáng Sản",
      intro: "(Phòng 2: Thị trường kim loại khoáng sản)",
      des: "Tối thiểu 30,000",
      url: "https://gialuongthucthegioi.com/user/rooms/vip",
      soLuong: Math.floor(Math.random() * 7000000),
    },
    {
      name: "Phòng 3: Thị trường Năng Lượng - Nhiên Liệu",
      intro: "(Phòng 3: Thị trường Năng lượng - Nhiên liệu)",
      des: "Tối thiểu 150,000",
      url: "https://gialuongthucthegioi.com/user/rooms/superio",
      soLuong: Math.floor(Math.random() * 5000000),
    },
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      setListPhong((prevList: any) =>
        prevList.map((room: any) => ({
          ...room,
          soLuong: room.soLuong + Math.floor(Math.random() * 10 + 1), // Tăng ngẫu nhiên từ 1 đến 10
        }))
      );
    }, 2000); // Cập nhật mỗi 2 giây

    return () => clearInterval(interval); // Cleanup interval
  }, []);

  const onClickPhong = (item: any) => {
    if (
      item?.name == "Phòng 2: Thị trường Kim Loại - khoáng Sản" &&
      user?.balance < 30000
    ) {
      ToastInfo("Vốn phòng tối thiểu 30,000");
      return;
    }
    if (
      item?.name == "Phòng 3: Thị trường Năng lượng - Nhiên liệu" &&
      user?.balance < 150000
    ) {
      ToastInfo("Vốn phòng tối thiểu 150.000");
      return;
    }
    window.open(item?.url, "_blank");
  };

  return (
    <div className="" style={{ borderRadius: 5 }}>
      <div>
        <CRow className="g-2">
          {listPhong.map((item, index) => {
            return (
              <CCol
                className="cursor-pointer"
                xs={12}
                xxl={6}
                key={index}
                style={{ fontSize: 12 }}
                onClick={() => onClickPhong(item)}
              >
                <div className={`custom-img-phong img${index}`}>
                  <div className="ratio-box-content d-flex flex-column justify-content-between">
                    <div>
                      <h5 style={{ fontSize: 14 }} className="mb-0">
                        {item?.name}
                      </h5>
                    </div>
                    <p className="mb-0 d-flex  align-items-center gap-1">
                      <img
                        style={{ width: 13, height: 13 }}
                        src="data:image/png;base64,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"
                      />
                      <span>{formatUSDNoCurrency(item?.soLuong)}</span>
                    </p>
                    <p className="mb-0">{item?.des}</p>
                  </div>
                </div>
              </CCol>
            );
          })}
        </CRow>
      </div>
    </div>
  );
};

export default ListRoom;
